import { createUseStyles } from "react-jss";
import { COLORS } from "../../EatClubTheme.js";
const useStyles = createUseStyles(
  (theme) => ({
    container: (props) => {
      var _a;
      return {
        ...props == null ? void 0 : props.style,
        ...(_a = props == null ? void 0 : props.style) == null ? void 0 : _a.container
      };
    },
    label: (props) => {
      var _a;
      return {
        ...(_a = props == null ? void 0 : props.style) == null ? void 0 : _a.label
      };
    },
    textField: (props) => {
      var _a;
      return {
        ...(_a = props == null ? void 0 : props.style) == null ? void 0 : _a.textField
      };
    },
    textFieldInner: (props) => {
      var _a;
      return {
        position: "relative",
        ...(_a = props == null ? void 0 : props.style) == null ? void 0 : _a.textFieldInner
      };
    },
    disabled: (props) => {
      var _a;
      return {
        ...(_a = props == null ? void 0 : props.style) == null ? void 0 : _a.disabled
      };
    },
    placeholder: (props) => {
      var _a;
      return {
        color: "blue",
        ...(_a = props == null ? void 0 : props.style) == null ? void 0 : _a.placeholder
      };
    },
    input: (props) => {
      var _a;
      return {
        "&::placeholder": {
          color: COLORS.NIMBUS,
          opacity: 1
        },
        ...(_a = props == null ? void 0 : props.style) == null ? void 0 : _a.input
      };
    },
    inputPrefix: (props) => {
      var _a;
      return {
        position: "absolute",
        // marginTop: "10px",
        marginLeft: "10px",
        top: "50%",
        transform: "translateY(-50%)",
        ...(_a = props == null ? void 0 : props.style) == null ? void 0 : _a.inputPrefix
      };
    },
    inputHover: (props) => {
      var _a;
      return {
        ...(_a = props == null ? void 0 : props.style) == null ? void 0 : _a.inputHover
      };
    },
    inputActive: (props) => {
      var _a;
      return {
        ...(_a = props == null ? void 0 : props.style) == null ? void 0 : _a.inputActive
      };
    }
  }),
  { name: "ECTextField" }
);
export {
  useStyles as default
};
//# sourceMappingURL=TextFieldStyles.js.map
